import React, {Component} from 'react';
import './subject.scss';
import $ from 'jquery';
import API from './../../config/api';
import Tool from './../../utils/tool';
import {connect} from 'react-redux';
import {refresh_admin} from './../../redux/models/admin';
import Header from "../../components/Header/header";
import {Toast} from 'antd-mobile';
import AppBtn from "../../components/AppBtn/appBtn";
import TopBtn from "../../components/TopBtn/topBtn";
import { copyFileSync } from 'fs';

const TYPE = {
  NORMAL: 'NORMAL',
  TIME: 'TIME',
}


@connect(
  state => ({admin: state.admin}),
  {refresh_admin}
)

class Subject extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {},
      uuid: '',
      type: TYPE.NORMAL,
      name: '',
      isPc: true
    };

  }

  componentWillMount() {
    $('html,body').css({
      'background-color': '#F4F4F4'
    })
    this.getContentId();
    this.getContent();
    this.statistics()
    // this.ymstatistics()
  }

  componentDidMount() {
    if (this.state.type === TYPE.TIME) {
      this.initMap()
    }
    this._isPc()
  }

  componentWillUnmount() {

  }
  //判断是否是pc
  _isPc = () => {
    if (!(navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
      this.setState({
        isPc: false
      })
    }
  }

  render() {
    const {data, uuid, type,name,isPc} = this.state;

    return (
      <div className="subject-box">

        {/*头部*/}
        <Header name={name} uuid={uuid}/>

        {/*专题头部*/}
        <div className="subject-head-box" style={{
          backgroundImage: 'url(' + data.big_cover + ')'
        }}></div>


        {/*专题列表*/}
        {
          type === TYPE.NORMAL ? (
            <div className="subject-normal-list">
              {
                data.list.map((item, index) => {
                  return (
                    <div className="subject-item" key={index}
                         onClick={this.goDetail.bind(this, item)}>
                      {/* <div className="left" style={{
                        backgroundImage: 'url(' + item.row.cover_list[0].url + ')'
                      }}></div> */}
                      {/* <div className="right">
                        <div className="title" style={{
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          display: '-webkit-box',
                          'WebkitLineClamp': '2',
                          'WebkitBoxOrient': 'vertical',
                        }}>{item.row.title}</div>
                        <div className="subject-item-info">
                          <div className="info-left">
                            {
                              item.row.column_info.map((childItem, childIndex) => {
                                return (
                                  <div key={childIndex}
                                       className="column-item">{childItem.column_name}</div>
                                )
                              })
                            }
                          </div>
                          <div className="info-right">
                            <div
                              className="time">{Tool.dateFormat_new(item.row.publish_timestamp)}</div>
                          </div>
                        </div>
                      </div> */}
                        <div className="subject_item_box">
                          <div className="title" style={{
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            display: '-webkit-box',
                            'WebkitLineClamp': '2',
                            'WebkitBoxOrient': 'vertical',
                          }}>{item.row.title}</div>
                          <div className="subject-item-info">
                            <div className="info-left">
                              {
                                item.row.column_info.map((childItem, childIndex) => {
                                  return (
                                    <div key={childIndex}
                                        className="column-item">{childItem.column_name}</div>
                                  )
                                })
                              }
                            </div>
                            <div className="info-right">
                              <div className="time">{Tool.dateFormat_new(item.row.publish_timestamp)}</div>
                            </div>
                          </div>
                        </div>
                    </div>
                  )
                })
              }
            </div>
          ) : (
            <div className="subject-time-box">
              {/*专题题目*/}
              <div className="subject-title">
                <div className="title" style={{
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  display: '-webkit-box',
                  'WebkitLineClamp': '2',
                  'WebkitBoxOrient': 'vertical',
                }}>{data.desc}</div>
              </div>
              {/*专题列表*/}
              <div className="subject-time-list">
                {
                  data.list.map((item, index) => {
                    switch (parseInt(item.row.module_type)) {
                      case 1:             //时间
                        return (
                          <div className="subject-day-box" key={index}>
                            {/*时间*/}
                            <div className="time-icon">
                              <div
                                className="month">{item.row.module_date.split('-')[1]}</div>
                              <div className="day">{item.row.module_date.split('-')[2]}</div>
                            </div>
                            {/*新闻列表*/}
                            {
                              item.row.manuscript_list.map((news_item, news_index) => {
                                return (
                                  <div className="newsItem" key={news_index}
                                       onClick={this.goDetail.bind(this, news_item)}>
                                    <div className="pic" style={{
                                      // backgroundImage: 'url(' + news_item.cover + ')'
                                      backgroundImage: 'url(' + item.row.cover_list[0].url + ')'
                                    }}
                                    ></div>
                                    <div className="text-box">
                                      <div className="text" style={{
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        display: '-webkit-box',
                                        'WebkitLineClamp': '2',
                                        'WebkitBoxOrient': 'vertical',
                                      }}>{news_item.title}</div>
                                    </div>
                                  </div>
                                )
                              })
                            }
                          </div>
                        )
                        break;
                      case 2:             //地点
                        return (
                          <div className="subject-position-box" key={index}>
                            <div className="position-text">地点</div>
                            <div className="positionItem">
                              {/*地图*/}
                              <div className="map">
                                <div id="container"></div>
                              </div>
                              {/*地图信息*/}
                              <div className="position-info">
                                <div className="text">{item.row.module_data.location}</div>
                              </div>
                            </div>
                          </div>
                        )
                        break;
                      case 3:             //人物
                        return (
                          <div className="subject-person-box" key={index}>
                            <div className="person-text">人物</div>
                            <div className="person-list">
                              {/*新闻列表*/}
                              {
                                item.row.person_list.map((person_item, person_index) => {
                                  return (
                                    <div className="personItem" key={person_index}>
                                      <div className="left" style={{
                                        backgroundImage: 'url(' + person_item.head_image + ')'
                                      }}></div>
                                      <div className="right">
                                        <div
                                          className="name">{person_item.user_name}</div>
                                        <div className="text" style={{
                                          overflow: 'hidden',
                                          textOverflow: 'ellipsis',
                                          display: '-webkit-box',
                                          'WebkitLineClamp': '2',
                                          'WebkitBoxOrient': 'vertical',
                                        }}>{person_item.keyword}</div>
                                      </div>
                                    </div>
                                  )
                                })
                              }
                            </div>
                          </div>
                        )
                        break;
                        default:''
                    }
                  })
                }
              </div>

              <TopBtn type={1}/>

            </div>
          )
        }


        {/*打开APP按钮*/}
        {isPc ? <AppBtn name={this.state.name} uuid={this.state.uuid} style={{marginTop: '.78rem'}}
                text="打开新京报App，阅读体验更佳"/> : ''}
        

      </div>
    );
  }

  ymstatistics() {
    setTimeout(() => {
      if (window._czc) {
        let location = window.location
        let contentUrl = location.pathname + location.hash
        let refererUrl = '/'
        window._czc.push(['_trackPageview', contentUrl], refererUrl)
      } else {
        console.log('_czc null')
      }
    }, 2000)
  }

  getContentId() {
    // console.log(this.props);
    const {uuid, type} = this.props.match.params;
    if (uuid && type) {
      this.state.uuid = uuid
      if (parseInt(type) === 1) {     //1
        this.setState({
          type: TYPE.NORMAL,
          name: 'normalSpecial'
        })
      } else {                        //2
        this.setState({
          type: TYPE.TIME,
          name: 'timeLineSpecial'
        })
      }
    } else {
      this.props.history.push('./');
    }
  }

  getContent() {
    $.ajax({
      type: 'get',
      url: API.special_detail,
      async: false,
      headers: {
        version: 'v104'
      },
      data: {
        uuid: this.state.uuid,
      },
      dataType: 'json'
    }).done((res) => {
      if (res.code == 0 || res.errorCode == 0) {
        this.setState({
          data: res.data
        })
        document.title = '专题 | ' + res.data.title;

        this.initWx({
          title: res.data.title,
          desc: res.data.desc,
        })
      } else {
        Toast.fail(res.msg || res.error);
      }
    });
  }

  initMap() {
    const {data} = this.state
    var latitude = -1;
    var longitude = -1;
    for (var i = 0; i < data.list.length; i++) {
      var temp = data.list[i];
      if (parseInt(temp.module_type) === 2) {
        latitude = parseFloat(temp.module_data.latitude)
        longitude = parseFloat(temp.module_data.longitude)
        break;
      }
    }
    if (latitude === -1) {
      return
    }

    var map = new window.AMap.Map('container', {
      center: [longitude, latitude],
      zoom: 11
    });

    // 创建 AMap.Icon 实例：
    var icon = new window.AMap.Icon({
      size: new window.AMap.Size(34, 39),    // 图标尺寸
      image: API.map_icon,  // Icon的图像
      // imageOffset: new window.AMap.Pixel(0, -60),  // 图像相对展示区域的偏移量，适于雪碧图等
      imageSize: new window.AMap.Size(34, 39)   // 根据所设置的大小拉伸或压缩图片
    });

    // 创建一个 Marker 实例：
    var marker = new window.AMap.Marker({
      position: new window.AMap.LngLat(longitude, latitude),
      // offset: new window.AMap.Pixel(-10, -10),
      icon: icon, // 添加 Icon 图标 URL
      title: '北京'
    });

    // 将创建的点标记添加到已有的地图实例：
    map.add(marker);
  }

    goDetail(item) {
      let _hostname = window.location.hostname;
    switch (parseInt(item.type)) {
      case 1:     //图文
        let jumpUrl1 = ``
        if (_hostname === 'cdn.bjnews.com.cn') {  //正式环境
          if(!this.state.isPc){
            window.location.href = `https://www.bjnews.com.cn/detail/${item.uuid}.html`
          }else {
            jumpUrl1 = `https://m.bjnews.com.cn/detail/${item.uuid}.html`
					  window.location.href = jumpUrl1
          }
        } else {   //测试环境
          if(!this.state.isPc){
            window.location.href = `https://www.bjnews.com.cn/detail/${item.uuid}.html`
          }else{
            this.props.history.push('/detail/1/' + item.uuid)
          }
        } 
        break;
      case 2:     //视频
        let jumpUrl2 = ``
        if (_hostname === 'cdn.bjnews.com.cn') {  //正式环境
          if(!this.state.isPc){
            window.location.href = `https://www.bjnews.com.cn/detail/${item.uuid}.html`
          }else {
            jumpUrl2 = `https://m.bjnews.com.cn/detail/${item.uuid}.html`
					  window.location.href = jumpUrl2
          }
        } else {   //测试环境
          if(!this.state.isPc){
            window.location.href = `https://www.bjnews.com.cn/detail/${item.uuid}.html`
          }else {
            this.props.history.push('/detail/2/' + item.uuid + '/2')
          }
        } 
        break;
      case 4:     //图说
        if(!this.state.isPc){
          window.location.href = `https://www.bjnews.com.cn/detail/${item.uuid}.html`
        }else {
          this.props.history.push('/detail/3/' + item.uuid)
        }
        break;
      case 6:     //直播
        if(!this.state.isPc){
          window.location.href = `https://www.bjnews.com.cn/detail/${item.uuid}.html`
        }else {
          this.props.history.push('/detail/2/' + item.uuid + '/6')
        }
        break;
      case 21:
        // const _hostname = window.location.hostname;
        let jumpUrl21 = `https://mtest.bjnews.com.cn/detail3?uuid=${item.uuid}`
        if (_hostname === 'cdn.bjnews.com.cn') {  //正式环境
          if(!this.state.isPc){
            jumpUrl21 = `https://www.bjnews.com.cn/detail/${item.uuid}.html`
          }else {
            jumpUrl21 = `https://m.bjnews.com.cn/detail3?uuid=${item.uuid}`
          }
        } else {   //测试环境
          if(!this.state.isPc){
            jumpUrl21 = `https://www.bjnews.com.cn/detail/${item.uuid}.html`
          }else {
            jumpUrl21 = `https://mtest.bjnews.com.cn/detail3?uuid=${item.uuid}`
          }
        } 
        window.location.href = jumpUrl21
        break;
      default:  ''
    }
  }

  statistics(share) {
    var op = share ? 'share' : 'pv';
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = API.pv + '?xm=bjnews&wz=article_detail&op=' + op + '&pt=wap&unique_id=' + this.state.uuid;     //填自己的js路径
    $('body').append(script);
  }

  initWx(obj) {
    //分享
    var wxconfig = new window.WxConfig();
    console.log(window.location.href);
    wxconfig.init({
      appid: API.appid,
      url: window.location.href,
      title: obj.title,
      desc: obj.desc || API.share_des,
      link: window.location.href,
      imgUrl: API.share_img,
      successCallback: this.statistics.bind(this, true)
    });
  }

}

export default Subject;


// WEBPACK FOOTER //
// ./src/pages/Subject/subject.js